const delay = {
     async sleep (timeInMs: number): Promise<void> {
        return await new Promise(r => setTimeout(r, timeInMs));
    }
}

export default delay;
